import { Component, EventEmitter, Output } from '@angular/core';
import { GradeType } from 'src/app/domain';
import { EditGradeService } from 'src/app/core/services/edit-grade.service';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-gpa-type',
    templateUrl: 'gpa-type.component.html',
    styleUrls: ['gpa-type.component.scss'],
    imports: [IonicModule, FormsModule]
})
export class GpaTypeComponent {
  constructor(public editGradeService: EditGradeService) {
    const gpaTypeFromService = this.editGradeService.gpaType;
    if (gpaTypeFromService) {
      this.type = gpaTypeFromService;
    }
  }
  type: string;
  readonly gradeTypes = GradeType;
  @Output() gpaType = new EventEmitter<string>();

  onTypeChange(type: string) {
    this.gpaType.emit(type);
    this.editGradeService.setGpaType(type);
  }
}
